import ConnectedBarcodeDetails from './ConnectedBarcodeDetails'
import PageHeader from '../../../common/PageHeader';
import { useIntl } from 'react-intl';

const ConnectedBarcode = () => {
  const {formatMessage} = useIntl();
  return (
    <>
      <PageHeader title={formatMessage({ id: "add_discount_bulk" })} />
      {/* Multi-supplier (B7): discounts attach to the supplier's own offer. */}
      <div className='alert alert-light-primary d-flex align-items-center' role='note'>
        <i className='fas fa-info-circle me-2' aria-hidden='true' />
        <span>{formatMessage({id: 'discount_selection_offer_note'})}</span>
      </div>
      <ConnectedBarcodeDetails />
    </>
  )
}

export default ConnectedBarcode